module.exports = __webpack_public_path__ + "static/media/29BDOS15.704143bd.jpg";